//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {
  IMaterializedTikTokVideoWithMetrics,
  ITikTokEngagementDailyStats,
  ITikTokEngagementMetrics,
  TikTokMetricSortKey,
} from '@apis/tiktok-analytics/tiktokAnalyticsApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import { TikTokEngagementPerformanceOption } from '@tiktok/components/analytics/engagement/tiktokEngagementConstants';

export interface ITikTokEngagementState {
  dateRange: IAliasedDateRange;
  dailyStats: ITikTokEngagementDailyStats[];
  summaryStats: ITikTokEngagementMetrics | undefined;
  currentGraphMetric: TikTokEngagementPerformanceOption;
  mediaPerformance: ITikTokMediaPerformanceState;
  flags: {
    isFetchingEngagementStats: boolean;
    isFetchingTopMedia: boolean;
  };
  errors: {
    fetchEngagementStatsError: string | undefined;
    fetchTopMediaError: string | undefined;
  };
}

export interface ITikTokMediaPerformanceState {
  isOrderAscending: boolean;
  limit: number;
  media: IMaterializedTikTokVideoWithMetrics[];
  offset: number;
  sortKey: TikTokMetricSortKey;
  total: number;
  view: TikTokTopMediaView;
}

export enum TikTokTopMediaView {
  TableView = 'table',
  GridView = 'grid',
}
